import {Component, OnDestroy, OnInit} from '@angular/core';


import {Subscription} from "rxjs";
 import {ActivatedRoute, Params, Router} from '@angular/router';
import {NbToastrService, NbGlobalPosition, NbDialogService } from '@nebular/theme';
 import {SocketQrEnterWatch} from '../shared/services/sockets'

@Component({
  selector: 'watchers-enter-qrkey',
  templateUrl: './watchers-enter-qrkey.component.html',
  styleUrls: ['./watchers-enter-qrkey.component.scss']
})
export class WatchersEnterQRkeyComponent implements OnInit, OnDestroy {
	

 loading:boolean = true
 blocked:boolean = false
  success:boolean = false
 streamWatchId:string = ''
sessionKey:string = ''
 socketKey:string = ''
 password:string = ''
 
  constructor( 
    public route:  ActivatedRoute,
    private router: Router,
    private socket: SocketQrEnterWatch,
    private toastrService: NbToastrService
  ) { 

      this.socket.removeAllListeners()
      this.socket.disconnect()
}

  ngOnInit() {
   
    this.route.params.subscribe((params: Params)=>{
        
		if(!params['streamWatchId'] || !params['sessionKey']){

			this.router.navigate(['channel'])
			return 
		}  

		this.streamWatchId = params['streamWatchId']
		this.sessionKey = params['sessionKey']
		this.socketKey = this.streamWatchId+'_'+this.sessionKey

				
 
		    this.socket.on('onCommand', this.onCommand.bind(this))
			
		  //  this.socket.on('exitByToken', this.exitByToken.bind(this))



		  this.socket.on('connect', ()=>{
		      this.socket.emit('onEnterPageJoin', 
		       {
			enterPageIdent: 'epj_'+this.socketKey,
			watchKey: this.socketKey
			}
		      )
		    })

		 this.socket.connect()
 
      })
  }


  onCommand({cmd, payload}){
 
	if(cmd === 'joined'){
		if(payload.canContinue === true){
			this.loading = false
			 this.blocked = false
		}else {
		this.loading = false
		this.blocked = true

		 this.toastrService.show(``,'Сторінку не знайдено',{
			status: 'danger',
			position: <NbGlobalPosition>'bottom-right',
			 icon: ''
		      })
		 
		

		}

		return
	}

        if(cmd === 'keyResponce'){
		this.loading = false
		if(payload.type === 'success'){

		 this.toastrService.show(``,'Вхід виконано',{
			status: 'success',
			position: <NbGlobalPosition>'bottom-right',
			 icon: ''
		      })

			this.success = true

				
		return
		}
		if(payload.type === 'error'){
		 this.toastrService.show(``,'Неправильний ключ',{
			status: 'danger',
			position: <NbGlobalPosition>'bottom-right',
			 icon: ''
		      })


		return
		}
 
	}
 
	if(cmd === 'allLeave'){

		 this.loading = false
		//
		if(!this.success){
		//this.loading = true
		 this.toastrService.show(``,'Сторінка входу закрита',{
			status: 'danger',
			position: <NbGlobalPosition>'bottom-right',
			 icon: ''
		      })
		 

		this.blocked = true
		// this.router.navigate(['channel'])
		 
		}

			//

		return
	}


      
	
      

  }


  submit(){
 	
	let key = this.password.trim()
    if(key === ''){
      return
    }

	this.loading = true

	this.socket.emit('keyEnter',key)

  }


  ngOnDestroy(){
	 
	 

		
	    this.socket.removeAllListeners()
	    this.socket.disconnect()
  }



}
